import { AppInputParsedData, AppInputRawData } from "./App.types";
import { Nullable } from "./utils/types";
import { safeParseInt } from "./utils/common.utils";

export class ShadowRootDom {
  private static _shadowRootNode: ShadowRoot | undefined;
  private static _appContainer: HTMLDivElement | undefined;

  public static get shadowRootNode() {
    return ShadowRootDom._shadowRootNode;
  }

  public static get appContainer() {
    return ShadowRootDom._appContainer;
  }

  public static setShadowRootNode(shadowRootNode: ShadowRoot) {
    ShadowRootDom._shadowRootNode = shadowRootNode;
  }

  public static setAppContainer(appContainer: HTMLDivElement) {
    ShadowRootDom._appContainer = appContainer;
  }

  public static querySelector<T extends HTMLElement>(selector: string): T | null {
    // Search order: shadow root → app container → document
    return (
      (ShadowRootDom._shadowRootNode?.querySelector(selector) as T | null) ??
      (ShadowRootDom._appContainer?.querySelector(selector) as T | null) ??
      document.querySelector<T>(selector)
    );
  }
}

export { ShadowRootDom as AppDOM };

export const createAppInputDataWithDefaults = (data: Partial<AppInputParsedData>): AppInputParsedData => ({
  options: {
    platformId: data?.options?.platformId ?? undefined,
    authTokenUrl: data?.options?.authTokenUrl,
    shadowDom: data?.options?.shadowDom !== false && data?.options?.shadowDom !== "false",
    lang: data?.options?.lang,
  },
});

export const parseAppInputData = (data: Nullable<Partial<AppInputRawData>>): AppInputParsedData => {
  const rest = data ?? {};

  const platformId = typeof rest?.platform === "string" ? safeParseInt(rest?.platform, 0) : rest?.platform;

  return createAppInputDataWithDefaults({
    options: {
      platformId,
      authTokenUrl: rest?.authTokenUrl,
      shadowDom: rest?.shadowDom,
      lang: rest?.lang,
    },
  });
};
